import { createSelector } from '@reduxjs/toolkit'

import type { ReduxState } from 'src/store/types'

const getUiState = (state: ReduxState) => state.ui

export const getUiStateSelector = createSelector(getUiState, (ui) => ui)

export const getIsMenuOpenedSelector = createSelector(getUiStateSelector, (ui) => ui.isMenuOpened)

export const getPendingDialogSelector = createSelector(getUiStateSelector, (ui) => ui.pendingDialog)
